import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between mb-2" }
const _hoisted_2 = { class: "text-sm font-medium truncate" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_4 = { class: "flex items-center gap-1.5 text-xs text-muted-foreground" }
const _hoisted_5 = { class: "flex items-center gap-1.5 text-xs text-muted-foreground" }
const _hoisted_6 = { class: "flex items-center gap-1.5 text-xs text-muted-foreground" }
const _hoisted_7 = { class: "flex items-center gap-1.5 text-xs text-muted-foreground" }

import { Badge } from '@/components/ui/badge'
import { Card, CardContent } from '@/components/ui/card'
import { Progress } from '@/components/ui/progress'
import {
  ListTodo,
  Monitor,
  CalendarDays,
  FileText,
} from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectSummaryCard',
  props: {
    projectName: {},
    projectStatus: {},
    stats: {}
  },
  setup(__props: any) {

const props = __props

const getStatusVariant = (status: string) => {
  const variants: Record<string, string> = {
    definition: 'bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-300',
    in_development: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
    qa: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
    uat: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
    production: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    maintenance: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300',
    completed: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-300',
    on_hold: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300',
  }
  return variants[status] || variants.definition
}

const getStatusLabel = (status: string) => {
  const labels: Record<string, string> = {
    definition: 'Definicion',
    in_development: 'En Desarrollo',
    qa: 'QA',
    uat: 'UAT',
    production: 'Produccion',
    maintenance: 'Mantenimiento',
    completed: 'Completado',
    on_hold: 'En Pausa',
  }
  return labels[status] || status
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "border-dashed" }, {
    default: _withCtx(() => [
      _createVNode(_unref(CardContent), { class: "p-3" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(__props.projectName), 1),
            _createVNode(_unref(Badge), {
              class: _normalizeClass([getStatusVariant(__props.projectStatus), "text-[10px] shrink-0"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(getStatusLabel(__props.projectStatus)), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(ListTodo), { class: "h-3.5 w-3.5" }),
              _createElementVNode("span", null, _toDisplayString(__props.stats.totalReqs) + " reqs", 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(Monitor), { class: "h-3.5 w-3.5" }),
              _createElementVNode("span", null, _toDisplayString(__props.stats.totalApps) + " apps", 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(CalendarDays), { class: "h-3.5 w-3.5" }),
              _createElementVNode("span", null, _toDisplayString(__props.stats.totalMeetings) + " reuniones", 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(FileText), { class: "h-3.5 w-3.5" }),
              _createElementVNode("span", null, _toDisplayString(__props.stats.totalDocs) + " docs", 1)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})